import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getMutualCommunitiesAction } from "../../redux/actions/userActions";
import CommonLoading from "../loader/CommonLoading";
import { IoMdPeople } from "react-icons/io";
import placeholder from "../../assets/placeholder.png";

const MutualCommunitiesCard = ({ userId }) => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.auth?.userData);
  const mutualCommunities = useSelector((state) => state.user?.mutualCommunities);
  const mutualCommunitiesLoading = useSelector((state) => state.user?.mutualCommunitiesLoading);
  const [isCommunitiesExpanded, setIsCommunitiesExpanded] = useState(false);

  // Only fetch mutual communities if user is logged in
  useEffect(() => {
    if (userId && userData) {
      dispatch(getMutualCommunitiesAction(userId));
    }
  }, [dispatch, userId, userData]);

  // Don't show mutual communities if user is not logged in
  if (!userData) {
    return null;
  }

  if (mutualCommunitiesLoading) {
    return (
      <div className="bg-white rounded-lg border p-4 shadow-sm">
        <h5 className="mb-4 text-sm font-semibold font-roboto-flex">Mutual Communities</h5>
        <div className="flex justify-center items-center py-8">
          <CommonLoading />
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg border p-3 md:p-4 shadow-sm">
      <div className="flex items-center justify-between mb-3">
        <h5 className="text-sm font-semibold font-roboto-flex">Mutual Communities</h5>
      </div>
      
      {mutualCommunities?.length === 0 ? (
        <div className="text-center text-gray-400 font-roboto-flex py-2 md:py-3 text-xs md:text-sm">
          No mutual communities found
        </div>
      ) : (
        <>
          <div className="space-y-1">
            {(isCommunitiesExpanded ? mutualCommunities : mutualCommunities.slice(0, 5)).map((community) => (
              <Link
                key={community._id}
                to={`/skills-feed/${community.name}`}
                className="flex items-center gap-1 py-2 pl-1 pr-3 rounded-lg hover:bg-gray-50 transition-colors"
              >
                <img
                  className="w-10 h-10 md:w-12 md:h-12 rounded-full flex-shrink-0 object-cover"
                  src={community.avatar || placeholder}
                  alt={community.name}
                />
                <div className="min-w-0 flex-1">
                  <div className="group relative">
                    <p className="text-xs md:text-sm font-medium font-roboto-flex break-words">{community.name}</p>
                    <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-10 font-roboto-flex">
                      {community.name}
                    </div>
                  </div>
                  <p className="text-xs text-gray-500 flex items-center gap-1 font-roboto-flex">
                    <IoMdPeople className="text-xs" />
                    {community.memberCount}
                  </p>
                </div>
              </Link>
            ))}
          </div>

          {/* See All Button - Only show if more than 5 communities */}
          {mutualCommunities.length > 5 && (
            <div className="mt-3 pt-2 border-t border-gray-100">
              <button
                onClick={() => setIsCommunitiesExpanded(!isCommunitiesExpanded)}
                className="flex items-center gap-1 text-xs font-medium text-primary-700 hover:text-primary-800 transition-colors font-roboto-flex whitespace-nowrap w-full justify-center"
              >
                {isCommunitiesExpanded ? 'Show Less' : 'See All'}
                {!isCommunitiesExpanded && (
                  <span className="text-white text-xs bg-primary-700 w-4 h-4 rounded-full flex justify-center items-center font-medium font-roboto-flex">
                    {mutualCommunities.length}
                  </span>
                )}
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default MutualCommunitiesCard;
